import { jsx as _jsx } from "react/jsx-runtime";
import { Box, debounce } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useLayoutEffect, useState } from "react";
import { createKey } from "../../utils/createKey";
import { ItemChip } from "./ItemChip";
export const useStyles = makeStyles(() => ({
    clickableChip: {
        "&.MuiChip-label": {
            textDecoration: "underline",
        },
    },
}));
export const RecipeTypeChips = ({ recipeTypeChips, handleClick, setDialogContentMode, setIsDetailDialogOpen, isDetailDialogOpen, }) => {
    const [maxChipsCalculated, setMaxChipsCalculated] = useState(3);
    const classes = useStyles();
    const recipeTypeChipsToRender = recipeTypeChips.length > maxChipsCalculated
        ? recipeTypeChips.slice(0, maxChipsCalculated).map((rt, index) => {
            if (index === recipeTypeChips.slice(0, maxChipsCalculated).length - 1) {
                const remainingChips = recipeTypeChips && (recipeTypeChips === null || recipeTypeChips === void 0 ? void 0 : recipeTypeChips.length) - (maxChipsCalculated - 1);
                return {
                    label: `+${remainingChips} more...`,
                    clickable: true,
                };
            }
            else {
                return rt;
            }
        })
        : recipeTypeChips;
    useLayoutEffect(() => {
        let isMounted = true;
        const recipeChipsWraps = document.querySelectorAll(".recipe-chips");
        const handleResize = debounce((entries) => {
            try {
                if (isMounted) {
                    entries.forEach((entry) => {
                        const { width } = entry.contentRect;
                        setMaxChipsCalculated(Math.floor(width / 70));
                    });
                }
            }
            catch (error) {
                console.error("Error in Recipe Type Chip ResizeObserver callback:", error);
            }
        }, 50);
        const recipeChipsWrapObserver = new ResizeObserver(handleResize);
        recipeChipsWraps.forEach((chipsWrap) => {
            recipeChipsWrapObserver.observe(chipsWrap);
        });
        return () => {
            isMounted = false;
            recipeChipsWrapObserver.disconnect();
        };
    }, []);
    return (_jsx(Box, Object.assign({ display: "flex", justifyContent: "flexStart", flexWrap: "wrap", width: "100%", maxHeight: "1.5rem", overflow: "hidden", className: "recipe-chips" }, { children: recipeTypeChipsToRender.map((rt) => (_jsx(ItemChip, { classes: { label: rt.clickable ? classes.clickableChip : "" }, label: rt.label, clickable: rt.clickable, onClick: rt.clickable ? handleClick(setDialogContentMode, setIsDetailDialogOpen, isDetailDialogOpen) : undefined }, createKey()))) })));
};
